import { render, staticRenderFns } from "./form_add.vue?vue&type=template&id=e5512fbc&scoped=true"
import script from "./form_add.vue?vue&type=script&lang=js"
export * from "./form_add.vue?vue&type=script&lang=js"
import style0 from "./form_add.vue?vue&type=style&index=0&id=e5512fbc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5512fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5512fbc')) {
      api.createRecord('e5512fbc', component.options)
    } else {
      api.reload('e5512fbc', component.options)
    }
    module.hot.accept("./form_add.vue?vue&type=template&id=e5512fbc&scoped=true", function () {
      api.rerender('e5512fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/competitor_product/competitor_product_management/form/components/form_add.vue"
export default component.exports